import React from 'react';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { Chip, Stack, Tooltip } from '@mui/material';

import { tcc } from './palette';
import { CommandDeparture } from './types';

export default function DepartureStatus({ departure: d }: { departure: CommandDeparture }) {
  const state =
    d.days_to_handback < 0
      ? 'Handed Back'
      : (d.on_sale ?? d.state === 'On sale')
        ? 'On Sale'
        : d.state === 'Sold out'
          ? 'Sold out'
          : 'Closed';
  return (
    <Stack gap={0.5} alignItems="flex-start" data-departure-status>
      <Tooltip title={d.on_sale_via ? `On sale through LTLE package ${d.on_sale_via}` : ''}>
        <Chip
          size="small"
          label={state}
          variant={state === 'Closed' || state === 'Sold out' ? 'outlined' : 'filled'}
          sx={{
            minWidth: 100,
            fontSize: 12,
            bgcolor:
              state === 'On Sale' ? 'rgba(20,145,130,.12)' : state === 'Handed Back' ? 'action.hover' : 'transparent',
            color: state === 'On Sale' ? tcc.saleText : 'text.secondary',
            borderColor: 'text.secondary',
          }}
        />
      </Tooltip>
      {d.hidden && (
        <Chip
          size="small"
          variant="outlined"
          icon={<VisibilityOffOutlinedIcon />}
          label="Hidden"
          data-hidden-pill
          sx={{ fontSize: 11, height: 24, '& .MuiChip-icon': { fontSize: 14 } }}
        />
      )}
    </Stack>
  );
}
